import { getFunctions, httpsCallable } from "firebase/functions";

const DEFAULT_MODEL = "gemini-2.5-flash";
/** Match long schema_v2 drafts; server callGemini is 300s. Default SDK timeout is 70s. */
const CALL_GEMINI_TIMEOUT_MS = 320000;

let cachedFn = null;

function getCallGeminiFn() {
  if (!cachedFn) {
    cachedFn = httpsCallable(getFunctions(), "callGemini", {
      timeout: CALL_GEMINI_TIMEOUT_MS,
    });
  }
  return cachedFn;
}

/** Server-side Gemini via Cloud Function — no API key in the browser bundle. */
export async function geminiGenerateText(prompt, model = DEFAULT_MODEL) {
  const fn = getCallGeminiFn();
  const result = await fn({ prompt, model });
  return result.data?.text || "";
}

/**
 * Extract the first complete JSON object from Gemini text.
 * Models often append commentary or a second object after the payload;
 * first-{ to last-} slicing then fails with "Unexpected non-whitespace after JSON".
 */
export function extractJsonFromGeminiText(text) {
  let raw = String(text || "").trim();
  if (!raw) {
    throw new Error("AI did not return valid JSON.");
  }

  const fence = raw.match(/```(?:json)?\s*([\s\S]*?)```/i);
  if (fence && fence[1]) {
    raw = fence[1].trim();
  }

  const start = raw.indexOf("{");
  if (start === -1) {
    throw new Error("AI did not return valid JSON.");
  }

  let depth = 0;
  let inString = false;
  let escape = false;
  for (let i = start; i < raw.length; i++) {
    const ch = raw[i];
    if (inString) {
      if (escape) escape = false;
      else if (ch === "\\") escape = true;
      else if (ch === '"') inString = false;
      continue;
    }
    if (ch === '"') {
      inString = true;
      continue;
    }
    if (ch === "{") depth += 1;
    else if (ch === "}") {
      depth -= 1;
      if (depth === 0) {
        return JSON.parse(raw.slice(start, i + 1));
      }
    }
  }

  throw new Error("AI did not return a complete JSON object.");
}

export async function geminiGenerateJson(prompt, model = DEFAULT_MODEL) {
  const text = await geminiGenerateText(prompt, model);
  return extractJsonFromGeminiText(text);
}
